import * as views from '@/views';
import { IconBaseProps } from 'react-icons';

export type CorporateFlagsTheme = {
  name: string; // Nome da marca
  image: string; // Imagem da marca
  text_color: `#${string}`; // cor MENU
  active_color: `#${string}`; // cor TAB + MENU

  border_color: `#${string}`; // cor borda MENU

  bg_active_color: `#${string}`; // bg cor TAB + MENU
  bg_inactive_color: `#${string}`; // bg cor TAB
  
  bg_primary_color: `#${string}`; // bg cor TAB CONTAINER
  bg_secondary_color: `#${string}`; // bg cor TAB CONTAINER
  bg_tertiary_color: `#${string}`; // bg cor TAB CONTAINER
};

export type PackagesTypesProps = 'PT' | 'CT' | 'CE' | 'UN' | 'DP' | 'CX' | 'FD' | 'PK' | 'LT';

export interface PackagesProps {
  SG_EMBALAGEM: PackagesTypesProps;
  SG_COMISSAO: string;
}

export interface PriceProductProps extends PackagesProps {
  DT_FIM: string;
  COD_LOJA: number;
  TP_PROMO: string;
  VLR_PRECO: number;
  VLR_PAUTA: number;
  DT_INICIO: string;
  VLR_FINAL: number;
  DESTACA_ST: string;
  ST_PRODUTO: string;
  SEQFAMILIA: number;
  COD_PRODUTO: number;
  NROTABVENDA: string;
  NRO_SEGMENTO: number;
  COD_PROMOCAO: number;
  PERC_CLIENTE: number;
  QTD_EMBALAGEM: number;
  PERACRENTREGA: number;
  PERACRESCDESC: number;
  ST_VLR_FINAL?: number;
  ST_VLR_UNITARIO?: number;
  PERACRFINANCEIRO: number;
  NROCONDICAOPAGTO: number;
  QTD_MULTIPLO_VENDA: number;
  FAIXAACRFINANCEIRO: string;
  ST_VLR_FINAL_CART?: number;
  VLR_PRECO_CALCULADO: number;
  INDUSAACRESCTABVENDA: string;
  COD_TRIBUTACAO_PRODUTO: number;
}

export interface PackagingProductProps extends PackagesProps {
  COD_LOJA: number;
  MD_ALTURA: number;
  MD_LARGURA: number;
  MD_CUBAGEM: string;
  DUN_PRODUTO: number;
  EAN_PRODUTO: number;
  COD_PRODUTO: number;
  COD_SEGMENTO: number;
  QTD_CX_CAMADA: number;
  QTD_EMBALAGEM: number;
  MD_PESO_BRUTO: number;
  QTD_CX_PALETE: number;
  DESC_EMBALAGEM: string;
  MD_PESO_LIQUIDO: number;
  MD_PROFUNDIDADE: number;
  QTD_MULTIPLO_VENDA: number;
  PERC_MAX_FLEX: number;
  PERC_MIN_FLEX: number;
}

export type Attributes =
  | 'ean_grp'
  | 'dun_grp'
  | 'peso_grp'
  | 'grp_marca'
  | 'description'
  | 'familia_grp'
  | 'dimensao_grp'
  | 'fabricante_401'
  | 'embalagem_105'
  | 'tipo_81'
  | 'fragrância_201'
  | 'formato_101'
  | 'fabricante_grp'
  | 'description'
  | 'palavra_chave_grp'
  | 'cod_promocao';

export type ProductAttributesProps = {
  [key in Attributes]?: string;
};

export interface ProductProps {
  ultimaCompra: any;
  IMAGEM: string;
  ESTOQUE: number;
  COD_MARCA: number;
  COD_PRODUTO: number;
  COD_CATEGORIA: number;
  DESC_PRODUTO: string;
  DESC_PRODUTO_BUSCA: string;
  MD_RATING?: number;
  PRECO: PriceProductProps[];
  UNILEVER: boolean;
  FL_UNILEVER: 'True' | 'False';
  EMBALAGEM: PackagingProductProps[];
  ATRIBUTOS: ProductAttributesProps[];
}

export interface UltimaCompraProps {
  COD_LOJA: number;
  DT_COMPRA: number;
  NROREPRESENTANTE: number;
  QTDATENDIDA: number;
  QTDEMBALAGEM: number;
  SEQPESSOA: number;
  SEQPRODUTO: number;
  VALOR: number;
}

export interface DicUltimaCompraProps {
  [key: number]: UltimaCompraProps;
}

export interface BannerProps {
  ID?: string;
  LINK?: string;
  IMAGE: string;
  LABEL?: string;
}

export interface CategoryPropsWithExclusiveFields {
  link?: string;
  bold?: boolean;
  IMAGE?: string;
  isLive?: boolean;
  brands?: number[];
  DE_CATEGORIA: string;
  COD_CATEGORIA: number;
  PATH_CATEGORIA?: string;
  NRO_HIERARQUIA?: number;
  COD_CATEGORIA_PAI?: number;
  children?: CategoryProps[];
  ID_CATEGORIA_MAGENTO?: number;
}

export type LinkPropsModal = 'modal-companies' | 'modal-sync' | 'modal-coordinator';

export type NamedViews = keyof typeof views;

type DefaultLinkProps = {
  id: string;
  link: string;
  title: string;
  match?: string[];
  disabled?: boolean;
  icon?: IconBaseProps;
};

interface PropsModal extends DefaultLinkProps {
  view?: never;
  modal: LinkPropsModal;
  isProtected?: boolean;
  hasCart?: boolean;
}

interface PropsView extends DefaultLinkProps {
  modal?: never;
  view: NamedViews;
  isProtected?: boolean;
  hasCart?: boolean;
}

export type LinkProps = PropsView | PropsModal;

export type ClientProgress = 'danger' | 'semi-checked' | 'checked' | 'warning' | 'empty';

export interface PaymentConditionsProps {
  cod_condicao: number;
  desc_condicao: string;
}

export interface SegmentProps {
  desc: string;
  cod_segmento: number;
}

/** Campos por loja (multi-loja); a raiz do cliente espelha `lojas[0]` para compatibilidade. */
export interface ClientLojaProps {
  COD_LOJA: number;
  COD_SEGMENTO: SegmentProps[];
  COD_RCA: number;
  COD_TABELA_VENDA: number;
  COD_REGIME_TRIB: number;
  COD_CONDICAO_MAX: number;
  COD_CONDICAO_PADRAO: number;
  COD_PAGAMENTO: PaymentConditionsProps[];
  COD_ROTA: number;
}

export interface ClientProps {
  CEP: string;
  NR_TELEFONE?: string;
  COD_CLIENTE: number;
  COD_SEGMENTO: SegmentProps[];
  COD_LOJA: number;
  COD_REGIME_TRIB: number;
  COD_ROTA: number;
  COD_RCA: number;
  CYCLE: SalesCycleProps[];
  ST_CLIENTE: string;
  EMAIL: string;
  ST_COMPRA: string;
  NM_CLIENTE: string;
  NM_FANTASIA: string;
  NR_DOCUMENTO: string;
  COD_TABELA_VENDA: number;
  COD_CONDICAO_MAX: number;
  COD_CONDICAO_PADRAO: number;
  FL_UNILEVER: 'False' | 'True';
  UNILEVER: boolean;
  ENDERECO: string;
  NUMERO: string;
  BAIRRO: string;
  CIDADE: string;
  ESTADO: string;
  LIMITE_CREDITO: number;
  SALDO_DISPONIVEL: number;
  COD_PAGAMENTO: PaymentConditionsProps[];

  progress1: ClientProgress;
  progress2: ClientProgress;
  progress3: ClientProgress;
  progress4: ClientProgress;
  suspended?: boolean;
  notifications: number;
  daysWithoutPurchase: number;
  PERC_CLIENTE: number;
  DT_ULTIMA_COMPRA: DT_ULTIMA_COMPRA[];
  /** Presente quando o cliente veio agrupado por COD_CLIENTE (várias lojas). */
  lojas?: ClientLojaProps[];
}

export interface PedidosProps {
  nrotitulo: number;
  nro_pedvenda: number;
  parcelas: ParcelaProps[];
}

export interface ParcelaProps {
  vlroriginal: number;
  nroparcela: string;
  dt_vencimento: string;
  status: 'ABERTO' | 'VENCIDO' | 'PAGO';
}

export interface DT_ULTIMA_COMPRA {
  nro_representante: number;
  nro_segmento: number;
  dta_ult_compra: string;
}

export interface ClientAddressProps {
  street: string;
  address_number: string;
  region: string;
  state: string;
  city: string;
  cep: string;
  phone_number?: string;
  name: string;
}

export interface DataSetsProps {
  URL_S3: string;
  DT_UPDATE: string;
  TIPO_ARQUIVO: string;
  DESC_ARQUIVO: string;
  COD_LOJA?: number | string | null;
  COD_SEGMENTO?: number | string | null;
}

export interface RCAProps {
  id: number;
  name: string;
  image?: string;
  saldo?: number;
  agenda?: number;
  saldoFlex?: number;
  notificacoes?: boolean;
}

export interface RCAUsuarioProps {
  tipoUsuario: string;
  nomeUsuario: string;
  codPessoa: string;
  fechaPedido: boolean;
  viewDashboard: boolean;
}
export interface DataSetsProps {
  DT_UPDATE: string;
  TIPO_ARQUIVO: string;
  URL_S3: string;
  DESC_ARQUIVO: string;
  COD_LOJA?: number | string | null;
  COD_SEGMENTO?: number | string | null;
}

export interface DashboardsProps {
  metaFaturamento: {
    percentual: number;
    dashboard: number[];
    percentualReference: number;
  };
  positivacaoClientes: {
    percentual: number;
    dashboard: number[];
    percentualReference: number;
  };
  mediaPositivacaoDia: {
    percentual: number;
    dashboard: number[];
  };
  participacaoBazar: {
    percentual: number;
    dashboard: number[];
  };
  itensPorCliente: {
    percentual: number;
    dashboard: number[];
    percentualReference: number;
  };
  categoriaPilarMeta: {
    valor: number;
    dashboard: number[];
    valorAtingido: number;
    percentualReference: number;
  };
  categoriaPilarPositivacao: {
    valor: number;
    dashboard: number[];
    valorAtingido: number;
    percentualReference: number;
  };
}

export type TabCodes =
  | 'all'
  | 'noPurchases'
  | 'titles'
  | 'suspended'
  | 'active'
  | 'blocked'
  | 'withReturn'
  | 'notApproved'
  | 'approved'
  | 'activeTickets'
  | 'inactiveTickets'
  | 'tickets';

export interface TabParams {
  title: string;
  code: TabCodes;
  disabled?: boolean;
  notification: number;
}

export type CardMode = 'list' | 'grid';

/* 
  @description Descrição do card
  [DC] - Nome aparece desc_busca.
  [DE] - Nome aparece desc_produto.
  @example 'DC' | 'DE'
*/
export enum CardDescription {
  DC = 'DC',
  DE = 'DE',
}

export interface SalesCycleProps {
  DE: number;
  ATE: number;
  COD_RCA: number;
  POSITIVOU: number;
  COD_CLIENTE: number;
  SEMANA_CICLO_ID: number;
  STATUS_POSITIVACAO: 1 | 2 | 3 | 4;
  SEMANA_CICLO_ID_VIGENTE: number;
}
export interface FilterItemProps {
  id: number | string;
  title: string;
  count: number;
  checked: boolean;
  brands?: number[];
  type: 'category' | 'brand' | 'fabricante' | 'positivacao';
}

export interface AWSParamsProps {
  COD_LOJA: number;
  DESC_PARAMETRO: string;
  VALOR_PARAMETRO: string[];
}

export interface BrandProps {
  count?: number;
  ID_MARCA: number;
  checked?: boolean;
  categories?: number[];
  DESC_MARCA: string;
}

export interface productRestrictionClientProps {
  COD_CLIENTE: number;
  COD_PRODUTO: number;
}

export interface PageBuilderProps {
  ID: string;
  base64Img: string;
  list_sku: string[];
  desktop_image: string;
  type: 'banner' | 'vitrine';
  link_type: 'category' | 'product';
}

/**
 * @description Promoção do Cliente
 */

export interface IndicatorsFaixaProps {
  COD_AREA: number;
  DESCRICAO: string;
  GRUPO: string;
  ID_CAMPANHA: number;
  ID_PREMIO: number;
  INTERVALO_INFERIOR: number;
  INTERVALO_SUPERIOR: number;
  NRODIVISAO: number;
  NROEMPRESA: number;
  NROEQUIPE: number;
  NROREPRESENTANTE: number;
  NUMERO_FAIXA: number;
  PERFIL: string;
  STATUS: string;
  VLR_PREMIO: number;
}

export interface TopMixProps {
  COD_AREA: number;
  DATA_APURACAO: number;
  DESCRICAO: string;
  GRUPO: string;
  ID_CAMPANHA: number;
  ID_PREMIO: number;
  INTERVALO_INFERIOR_CLI: number;
  INTERVALO_INFERIOR_MIX: number;
  INTERVALO_SUPERIOR_CLI: number;
  INTERVALO_SUPERIOR_MIX: number;
  MES_ID: number;
  NRODIVISAO: number;
  NROEMPRESA: number;
  NROEQUIPE: number;
  NROREPRESENTANTE: number;
  NUMERO_FAIXA: number;
  PCT_MIX: number;
  PCT_POSITIVACAO: number;
  PERFIL: string;
  QTDE_CLIENTES: number;
  QTDE_CLIENTES_CARTEIRA: number;
  QTDE_PRODUTOS: number;
  QTD_TOTAL_PRODUTO: number;
  STATUS: string;
  VLR_PREMIO: number;
}
export interface IndicatorsProps {
  PERFIL: string;
  MES_ID: number;
  NRODIVISAO: number;
  NROEMPRESA: number;
  NROSEGMENTO: string;
  NROEQUIPE: number;
  ID_PREMIO: number;
  DESC_REDUZIDA: string;
  DESCRICAO: string;
  NUMERO_FAIXA: number;
  PCT_PREMIO: string;
  VLRITEM: number;
  VLRDEVOLITEM: number;
  VLR_PREMIO: number;
  PCT_META_ATINGIDO: number;
  META_NECESSARIA: number;
  PCT_COR: number;
  DIAS_UTEIS_MES_RESTANTES: number;
  DIAS_UTEIS_MES: number;
  NROREPRESENTANTE: string;
}
export interface PromocaoClientProps {
  COD_CLIENTE: number;
  TP_PROMO: string;
  COD_LOJA: number;
  NRO_SEGMENTO: number;
  COD_PRODUTO: number;
  QTD_EMBALAGEM: number;
  VLR_PRECO: number;
  ST_PRODUTO: string;
  SEQFAMILIA: number;
  DESTACA_ST: string;
  VLR_PAUTA: number;
  FAIXAACRFINANCEIRO: string;
  INDUSAACRESCTABVENDA: string;
  COD_TRIBUTACAO_PRODUTO: number;
  NRO_TAB_VENDA: number;
  ST_PROMOCAO: string;
  ST_COMPRA: string;
}
export interface TaxSubstitutionProps {
  COD_REGIME_CLIENTE: number;

  COD_TRIB_ITEM: number;
  SG_UF_ORIGEM: string;
  SG_UF_DESTINO: string;
  PERC_ALIQ_ICMS: number;
  PERC_TRIBUTADO_ICMS: number;
  PERC_MVA_ST: number;
  PERC_ALIQ_ST: number;
  PERC_TRIBUTADO_ST: number;
  PERC_FCP_ST: number;
  SEQ_TRIBUTACAO: number;
  DT_ATUALIZACAO: string;
}

export interface CustomerDataProps {
  email: string;
  tipoUsuario?: string;
  saldo?: number;
  image?: string;
  taxvat: string;
  agenda?: number;
  lastname: string;
  saldoERP?: number;
  firstname: string;
  saldoFlex?: number;
  codSegmento?: number;
  nomeUsuario?: string;
  codPessoa: number;
  cod_pessoa?: number;
  notificacoes?: boolean;
  phone: string;
}

export interface DiscountAtrProps {
  package: string;
  quantity: number;
  productId: number;
  percentual?: number;
  price?: { [key: string]: number };
  saldoAFaturar?: number;
}

export interface DiscountStorageProps {
  percentual?: number;
  discountPrice?: { [key: string]: number };
  saldoAFaturar?: number;
}
/**
 * @description a chave será a união de cliente, produto e embalagem
 */
export interface DiscountProps {
  [key: string]: DiscountStorageProps;
}
export interface RecomendacaoBigDataProps {
  MD_RATING: number;
  COD_PESSOA: number;
  COD_EMPRESA: number;
  COD_PRODUTO: number;
}

export interface StockProps {
  COD_LOJA: number;
  COD_PRODUTO: number;
  QTD_ESTOQUE: number;
  MSG_ESTOQUE?: string;
}

export interface ParametroPrecoBaseProps {
  NROTABVENDA: string;
  NROCONDICAOPAGTO: number;
  FAIXAACRFINANCEIRO: string;
  COD_LOJA: number;
  PERACRENTREGA: number;
  PERACRFINANCEIRO: number;
}

/** Folhas do JSON aninhado (chaves podem vir em minúsculas do backend). */
export interface ParametroPrecoBaseFaixaLeaf {
  peracrentrega?: number;
  peracrfinanceiro?: number;
  PERACRENTREGA?: number;
  PERACRFINANCEIRO?: number;
}

/**
 * Mesma informação que cada item do array legado `ParametroPrecoBaseProps[]`, em árvore:
 * [COD_LOJA][NROTABVENDA][NROCONDICAOPAGTO][FAIXAACRFINANCEIRO] → percentuais na folha.
 */
export type ParametroPrecoBaseNestedMap = Record<
  string,
  Record<string, Record<string, Record<string, ParametroPrecoBaseFaixaLeaf>>>
>;

export interface PercentualFornecedorProps {
  NROTABVENDA: string;
  PERACRESCDESC: number;
  SEQFAMILIA: number;
}

export interface CampanhaProdutosProps {
  nome: string;
  url_amigavel: string;
  ativo: CampanhaItemProdutoProps;
  inativo: CampanhaItemProdutoProps;
}

export interface CampanhaItemProdutoProps {
  selo: string;
  produto: number[];
  ids?: { [key: string]: string };
}

export interface CampanhaClientesProps {
  nome: string;
  url_amigavel: string;
  ativo: CampanhaItemClientesProps & { clientes: number[] };
  inativo: CampanhaItemClientesProps & { cliente: number[] };
}

export interface CampanhaItemClientesProps {
  selo: string;
  ids?: { [key: string]: string };
}

export interface PrecoPromocaoClienteProps {
  /**
   * @description [idCliente][qtdEmbalagem][idProduto][idLoja][idSegmento]
   */
  [key: number]: Record<number, Record<number, Record<number, Record<number, PromocaoClientProps>>>>;
}

export type CategoryProps =
  | (CategoryPropsWithExclusiveFields & { COD_CATEGORIA: number; PATH_CATEGORIA?: never })
  | (CategoryPropsWithExclusiveFields & { COD_CATEGORIA?: never; PATH_CATEGORIA: string; IMAGE?: string });

export type TableTypes = {
  preco: any;
  imagens: any;
  catalogo: any;
  saldo_flex: any;
  janela_entrega: any;
  pedidos_offline: any;
  marcas: BrandProps[];
  estoque: StockProps[];
  cliente: ClientProps[];
  produtos: ProductProps[];
  categoria: CategoryProps[];
  offline_events: LogEvents[];
  /* 
  @description Eventos do dataset de cliente_eventos
  */
  cliente_boletos: ClientEventsDataset;
  /* 
  @description Eventos do cliente com chave valor [idCliente][idBoleto]
  */
  eventos: EventsClientProps;
  campanha_indicador: IndicatorsProps[];
  campanha_faixa: IndicatorsFaixaProps[];
  campanha_mix_fornecedor: TopMixProps[];
  campanha_cliente: CampanhaClientesProps;
  campanha_produto: CampanhaProdutosProps;
  indicadores: IndicatorsProps[];
  parametros_aws: AWSParamsProps[];
  pagebuilder: PageBuilderProps[];
  ciclo_venda_cliente_cliente: SalesCycleProps[];
  parametro_preco_base: ParametroPrecoBaseProps[] | ParametroPrecoBaseNestedMap;
  cod_regime_tributario: TaxSubstitutionProps[];
  recomendacaoBigData: RecomendacaoBigDataProps[];
  percentual_fornecedor: PercentualFornecedorProps[];
  dicionario_produtos: Record<number, ProductProps>;
  dicionario_categorias: Record<number, CategoryProps>;
  restricaoProdutoCliente: productRestrictionClientProps[];
  indicador_loja: any;
  checkoutOrderData: any;
  checkoutOrderItems: any;
  checkoutCartTotals: any;
  ultima_compra: any;
  cliente_cortes: EventsClientCutReportProps[];
  /**
   * @description Preço Promocao. [idCliend][idProduto]
   */
  precoPromocaoCliente: PrecoPromocaoClienteProps;
};

export interface RelatorioCorteProps {
  qtd: number;
  qtdFat: number;
  desconto: number;
  cod: number;
  data: string;
  valorUnit: number;
  valor: number;
  descricao: string;
  status: string;
}

export const tableKeys = [
  'marcas',
  'indicadores',
  'campanha_indicador',
  'campanha_faixa',
  'campanha_mix_fornecedor',
  'produtos',
  'cliente',
  'categoria',
  'pagebuilder',
  'eventos',
  'cliente_boletos',
  'parametros_aws',
  'campanha_cliente',
  'campanha_produto',
  'cod_regime_tributario',
  'dicionario_categorias',
  'dicionario_produtos',
  'precoPromocaoCliente',
  'recomendacaoBigData',
  'ciclo_venda_cliente_cliente',
  'preco',
  'imagens',
  'estoque',
  'catalogo',
  'janela_entrega',
  'parametro_preco_base',
  'percentual_fornecedor',
  'pedidos_offline',
  'restricaoProdutoCliente',
  'saldo_flex',
  'indicador_loja',
  'offline_events',
  'checkoutOrderData',
  'checkoutOrderItems',
  'checkoutCartTotals',
  'ultima_compra',
  'cliente_cortes',
] as const;

export type Tables = (typeof tableKeys)[number];

export const listTables: Tables[] = [...tableKeys];

export interface ClientEventsDataset {
  clientes: EventsClientDataset[];
}

interface EventsClientDataset {
  cod_cliente: number;
  boletos: EventsClientBoletoDataset[];
}

type TipoEvento =
  | 'LOGIN'
  | 'HARDWARE'
  | 'VERSAO'
  | 'DOWNLOAD'
  | 'PROCESSAMENTO'
  | 'ROTA'
  | 'BOUNDARY'
  | 'SINC_VERSAO'
  | 'SINC_DATASETS'
  | 'NETWORK_STATUS'
  | 'FILTER'
  | 'TABLE_CONTEXT'
  | 'SEARCH'
  | 'DB_FUNCTIONS'
  | 'PAYMENT_CODE'
  | 'FLEX'
  | 'CART'
  | 'CHECKOUT_ERROR'
  | 'MENU_DASHBOARD';

export interface LogEvents {
  uuid: string;
  eventUUID: string;
  dtEvento: string;
  codRca: number;
  id: number;
  tipoUsuario: string;
  codCliente: number;
  codProduto: number;
  codLoja: number;
  stEvento: number;
  tipoEvento: TipoEvento;
  origemEvento: string;
  idCarrinho: number | null;
  origemDispositivo: string;
  rotaPagina: string;
  obsEvento: string;
}

interface EventsClientBoletoDataset {
  nro_pedido: string;
  nro_nota: number;
  parcelas: EventsClientParcelaDataset[];
}

interface EventsClientParcelaDataset {
  vlr_original: number;
  nro_parcela: string;
  dt_vencimento: string;
  status: string;
}

export interface EventsClientProps {
  /* 
  @description [idCliente]
  */
  [key: number]: {
    cod_cliente: number;
    boletos: EventsClientBoletoProps[];
  };
}

export interface EventsClientBoletoProps {
  nro_pedido: string;
  nro_nota: number;
  parcelas: EventsClientParcelaProps[];
}

export interface EventsClientParcelaProps {
  vlr_original: number;
  nro_parcela: string;
  dt_vencimento: string;
  status: string;
}

export enum EventsClientCutReportStatus {
  Faturado = 'Faturado',
  Cancelado = 'Cancelado',
  Indisponivel = 'Indisponivel',
  Integrado = 'Integrado',
  Separacao = 'Separacao',
  Entregue = 'Entregue',
  Emitido = 'Emitido',
  Reprocessar = 'Reprocessar',
  Processando = 'Processando',
  Roterizacao = 'Roterizacao',
}

export interface EventsClientCutReportProps {
  qtd: number;
  nome: string;
  vendedor: string;
  total_corte: number;
  data_emissao: string;
  rentabilidade: number;
  data_inclusao_erp: string;
  status: EventsClientCutReportStatus;
}
